import get from 'lodash/get';

import {
  PICKUP_ZONES_LOADING,
  FETCH_PICKUP_ZONES,
  DELETE_PICKUP_ZONE,
  UPDATE_PICKUP_ZONE,
  CREATE_PICKUP_ZONE,
  BULK_UPLOAD_PICKUP_ZONES,
} from '../actions/pickupZones';
import { VehicleZonesStatusNames } from '../lib/utils';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_PICKUP_ZONES: {
      const marketPickupZones = get(action, 'payload', []);
      const activeMarketPickupZones = marketPickupZones
        .filter((z) => z.status === VehicleZonesStatusNames.ACTIVE)
        .map((z) => ({ ...z, isPickup: true }));
      return {
        ...state,
        pickupZones: action.payload,
        activeMarketPickupZones,
      };
    }
    case PICKUP_ZONES_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case CREATE_PICKUP_ZONE:
    case DELETE_PICKUP_ZONE:
    case UPDATE_PICKUP_ZONE:
    case BULK_UPLOAD_PICKUP_ZONES:
    default:
      return state;
  }
}
